export const GET_TASKS_REQUEST = "GET_TASKS_REQUEST";
export const GET_TASKS_SUCCESS = "GET_TASKS_SUCCESS";
export const GET_TASKS_FAILURE = "GET_TASKS_FAILURE";

export const CREATE_TASKS_REQUEST = "CREATE_TASKS_REQUEST";
export const CREATE_TASKS_SUCCESS = "CREATE_TASKS_SUCCESS";
export const CREATE_TASKS_FAILURE = "CREATE_TASKS_FAILURE";

export const GET_TAG_REQUEST = "GET_TAG_REQUEST";
export const GET_TAG_SUCCESS = "GET_TAG_SUCCESS";
export const GET_TAG_FAILURE = "GET_TAG_FAILURE";

export const ADD_TAG_REQUEST = "ADD_TAG_REQUEST";
export const ADD_TAG_SUCCESS = "ADD_TAG_SUCCESS";
export const ADD_TAG_FAILURE = "ADD_TAG_FAILURE";

export const UPDATE_SUBTASKS_REQUEST = "UPDATE_SUBTASKS_REQUEST";
export const UPDATE_SUBTASKS_SUCCESS = "UPDATE_SUBTASKS_SUCCESS";
export const UPDATE_SUBTASKS_FAILURE = "UPDATE_SUBTASKS_FAILURE";

export const ADD_SUBTASKS_REQUEST = "ADD_SUBTASKS_REQUEST";
export const ADD_SUBTASKS_SUCCESS = "ADD_SUBTASKS_SUCCESS";
export const ADD_SUBTASKS_FAILURE = "ADD_SUBTASKS_FAILURE";

export const DELETE_SUBTASKS_REQUEST = "DELETE_SUBTASKS_REQUEST";
export const DELETE_SUBTASKS_SUCCESS = "DELETE_SUBTASKS_SUCCESS";
export const DELETE_SUBTASKS_FAILURE = "DELETE_SUBTASKS_FAILURE";

export const UPDATE_TASK_REQUEST = "UPDATE_TASK_REQUEST";
export const UPDATE_TASK_SUCCESS = "UPDATE_TASK_SUCCESS";
export const UPDATE_TASK_FAILURE = "UPDATE_TASK_FAILURE";
